import React from "react";

import "./services.scss";

const servicesData = [
  {
    icon: "flaticon-business",
    title: "Tour & Travel Solutions",
    desc: "Advanced travel technology solutions including booking systems, CRM platforms, itinerary management, and tourism portals.",
  },
  {
    icon: "flaticon-collaboration",
    title: "Cloud Managed Services",
    desc: "Secure and scalable cloud infrastructure, migration, hosting, and managed services for growing businesses.",
  },
  {
    icon: "flaticon-marketing-online",
    title: "Digital Marketing",
    desc: "Result-driven digital marketing solutions including SEO, social media marketing, branding, and online promotions.",
  },
  {
    icon: "flaticon-development1",
    title: "Software Development",
    desc: "Custom web, mobile, and enterprise software development tailored to business requirements and digital growth.",
  },
  {
    icon: "flaticon-monitoring",
    title: "IT Services & Consulting",
    desc: "Professional IT consulting, business automation, and technology strategies to improve operational efficiency.",
  },
  {
    icon: "flaticon-quality-1",
    title: "Technical Support",
    desc: "Reliable technical support, maintenance, troubleshooting, and system monitoring services for seamless operations.",
  },
];

const Services = () => {
  return (
    <section className="services">
      <div className="container">

        <div className="services-hero">
          <div className="row align-items-center">

            <div className="col-lg-6">
              <div className="hero-content">

                <span className="sub-title">
                  <i className="flaticon-check"></i>
                  Our Services
                </span>

                <h1>
                  Smart Digital Solutions <br />
                  for Modern Businesses
                </h1>

                <p>
                  GWCS delivers innovative IT solutions, enterprise software,
                  cloud services, and digital transformation strategies that
                  help businesses scale faster and operate smarter.
                </p>

                <div className="hero-buttons">
                  {/* <button className="primary-btn">
                    Explore Services
                  </button> */}

                  <button className="outline-btn">
                    Get Consultation
                  </button>
                </div>

              </div>
            </div>

            <div className="col-lg-6">
              <div className="hero-image">
                <img
                  src="/assets/images/services.jpg"
                  alt="Services"
                  className="img-fluid"
                />
              </div>
            </div>

          </div>
        </div>

        <div className="services-grid">

          <div className="section-header text-center">
            <span className="mini-title">
              What We Offer
            </span>

            <h2>
              End-to-End IT Services <br />
              Designed for Growth
            </h2>

            <p>
              From cloud infrastructure to custom software development,
              we provide complete digital solutions tailored to modern
              business challenges.
            </p>
          </div>

          <div className="row g-4">
            {servicesData.map((service, index) => (
              <div
                className="col-xl-4 col-lg-6 col-md-6"
                key={index}
              >
                <div className="service-card">

                  <div className="service-icon">
                    <i className={service.icon}></i>
                  </div>

                  <div className="service-content">

                    <h4>{service.title}</h4>

                    <p>{service.desc}</p>

                    {/* <a href="/" className="service-link">
                      Learn More
                      <i className="flaticon-right-arrow"></i>
                    </a> */}

                  </div>

                  <div className="card-shape"></div>

                </div>
              </div>
            ))}
          </div>

        </div>

        <div className="services-cta">
          <div className="cta-content">

            <h2>
              Ready to Transform Your Business Digitally?
            </h2>

            <p>
              Partner with GWCS to build secure, scalable,
              and future-ready technology solutions.
            </p>

            <button className="cta-btn">
              Contact Our Experts
            </button>

          </div>
        </div>

      </div>
    </section>
  );
};

export default Services;